import Map from '@rio-cloud/rio-uikit/Map';
import Marker from '@rio-cloud/rio-uikit/Marker';
import SingleMapMarker from '@rio-cloud/rio-uikit/SingleMapMarker';
import { config } from '../../config';

const MapEvents = (props: any) => {

    return (
        <div className='height-700'>
            <Map
                credentials={{
                    apikey: config.HERE_MAPS_KEY
                }}
                center={{
                    lat: props.lat,
                    lng: props.lng
                }}
                zoom={12}
                hideMapSettings
            >
                <Marker
                    position={{
                        lat: props.lat,
                        lng: props.lng
                    }}
                    icon={<SingleMapMarker iconNames={['truck']} markerColor='bg-map-marker-asset' active />}
                />
            </Map>
        </div>
    );
};

export default MapEvents;